import { Resume } from 'types/types';
import { SortField, SortOrder } from './resumeViewerTypes';

function getResumeSortValue(resume: Resume, field: SortField): string | number {
  switch (field) {
    case 'updatedAt':
      return resume.updatedAt?.getTime() || 0;
    case 'createdAt':
      return resume.createdAt?.getTime() || 0;
    case 'candidateId':
      return resume.candidate?.fullName?.toLowerCase() || resume.candidateId?.toLowerCase() || '';
    case 'jobId':
      return resume.job?.title?.toLowerCase() || resume.jobId?.toLowerCase() || '';
    default:
      return '';
  }
}

export function sortResumesList(
  resumesList: Resume[],
  field: SortField,
  order: SortOrder
): Resume[] {
  return [...resumesList].sort((a, b) => {
    const aValue = getResumeSortValue(a, field);
    const bValue = getResumeSortValue(b, field);
    if (aValue < bValue) return order === 'asc' ? -1 : 1;
    if (aValue > bValue) return order === 'asc' ? 1 : -1;
    return 0;
  });
}

export function filterResumes(resumes: Resume[], query: string): Resume[] {
  if (!query.trim()) return resumes;
  const normalized = query.toLowerCase();

  return resumes.filter(
    resume =>
      resume.candidate?.fullName?.toLowerCase().includes(normalized) ||
      resume.job?.title?.toLowerCase().includes(normalized) ||
      resume.job?.company?.toLowerCase().includes(normalized) ||
      resume.resume?.toLowerCase().includes(normalized) ||
      resume.id?.toLowerCase().includes(normalized)
  );
}
